(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lazy-video"] && !Shopify.designMode) return;
  try {
    (function() {
    var $url = document.querySelector('.as-lazy-video-script')
    if (!window.lazyVideo && $url) {
      window.lazyVideo = $url.value

      var $script = document.createElement('script')
      $script.src = window.lazyVideo
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meta-coupon-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.getElementById('meta-coupon-bar');
    if (!bar || bar.dataset.metaCouponInit) return;
    bar.dataset.metaCouponInit = '1';

    var STORE_ID = 'metaCouponCampaign';
    var STORE_CLOSED = 'metaCouponClosed';
    var CAMPAIGN_CODES = {
      '120249297628940141': 'Tk9UVEFQMTBN',
      '120249297629300141': 'Tk9UVEFQMTBN'
    };

    function read(key) { try { return window.sessionStorage.getItem(key); } catch (e) { return null; } }
    function write(key, val) { try { window.sessionStorage.setItem(key, val); } catch (e) {} }
    function push(name) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name });
    }

    var fromUrl = null;
    try { fromUrl = new URLSearchParams(window.location.search).get('campaign_id'); } catch (e) {}
    if (fromUrl && CAMPAIGN_CODES.hasOwnProperty(fromUrl)) write(STORE_ID, fromUrl);

    var matched = read(STORE_ID);
    if (!matched || !CAMPAIGN_CODES.hasOwnProperty(matched) || read(STORE_CLOSED) === '1') return;

    var code = '';
    try { code = window.atob(CAMPAIGN_CODES[matched]); } catch (e) {}
    if (!code) return;
    var codeEl = bar.querySelector('.meta-coupon-bar__code');
    codeEl.textContent = code;

    function setOffset(on) {
      document.body.classList.toggle('has-meta-coupon-bar', on);
      document.documentElement.style.setProperty('--meta-coupon-bar-h', on ? bar.offsetHeight + 'px' : '0px');
    }

    bar.hidden = false;
    setOffset(true);
    window.addEventListener('resize', function () { if (!bar.hidden) setOffset(true); });
    push('meta_coupon_view');

    var copyBtn = bar.querySelector('.meta-coupon-bar__copy');

    function label(text) {
      copyBtn.textContent = text;
      setTimeout(function () { copyBtn.textContent = copyBtn.dataset.copyLabel; }, 2000);
    }
    // アプリ内ブラウザなどで Clipboard API が使えない場合は、コードを選択状態にして案内する
    function fallback() {
      try {
        var range = document.createRange();
        range.selectNodeContents(codeEl);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        if (document.execCommand && document.execCommand('copy')) {
          push('meta_coupon_copy');
          label(copyBtn.dataset.copiedLabel);
          return;
        }
      } catch (e) {}
      label(copyBtn.dataset.failedLabel);
    }

    copyBtn.addEventListener('click', function () {
      if (!navigator.clipboard || !navigator.clipboard.writeText) { fallback(); return; }
      navigator.clipboard.writeText(code).then(function () {
        push('meta_coupon_copy');
        label(copyBtn.dataset.copiedLabel);
      }, fallback);
    });

    bar.querySelector('.meta-coupon-bar__close').addEventListener('click', function () {
      write(STORE_CLOSED, '1');
      bar.hidden = true;
      setOffset(false);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
